export default {
  FinanceReportSetting: {
    Title: 'Thiết lập báo cáo tài chính',
    Detail: {
      Title: 'Thiết lập công thức',
      SmaillTitle: 'Công thức nguồn vốn xã thực hiện (Col1)',
    },
  },

  QTDA16: {
    Title: 'Mẫu số 16/QTDA: Bảng đối chiếu số liệu sử dụng nguồn vốn đầu tư',
    Detail: {
      Formule: 'LKNOKDDA(2412) + LKNOKT(2412) - LKCOKDDA(2412) - LKCOKT(2412)',
    },
  },
};
